import { every, some } from "lodash-es";

export const convertBlobToFile = (file) => {
  const blob = new Blob([file], {
    type: file.type
  });

  blob.lastModifiedDate = file.lastModifiedDate;
  blob.name = file.name;

  return blob;
};

export const stepButtonsVisibility = ({ stepKey, questions = [] }) => {
  const isSingleQuestion = questions.length === 1;
  const isDocumentUploadStep = stepKey === "UPLOAD_DOCUMENTS";
  const isInformationalStep = stepKey === "THANK_YOU";
  const isAccidentResult = stepKey === "RESULT_ACCIDENT";
  const isFinal = stepKey === "RESULT_PARKING";
  const isFirstStep = stepKey === "VIOLATION_TYPE";
  const isResultInsuredOrNot = [
    "RESULT_PAGE_INSURED",
    "RESULT_PAGE_NOT_INSURED"
  ].includes(stepKey);

  const shouldDisplayButtons = every([
    !isFirstStep,
    !isInformationalStep,
    !isAccidentResult,
    !isResultInsuredOrNot
  ]);

  const shouldDisplayBack = every([!isFirstStep, !isInformationalStep]);

  const shouldDisplayNext = some([
    !(isFinal || isSingleQuestion),
    isDocumentUploadStep,
    isInformationalStep
  ]);

  return {
    shouldDisplayButtons,
    shouldDisplayBack,
    shouldDisplayNext
  };
};
